import { DialogBody, FormGroup, InputGroup, TextArea } from "@blueprintjs/core";
import { useUserDataContext } from "contexts/UserDataContext/UserDataContext";
import React, { useState } from "react";
import "./DetailsPanel.scss";
import { displayNameToScopeName } from "./useCreateUserScope";

interface DetailsPanelProps {
    readonly displayName: string;
    readonly notes: string;
    readonly niraBusId: string;
    readonly existingScopeNames: ReadonlyArray<string>;
    readonly onDisplayNameChange: (displayName: string) => void;
    readonly onNotesChange: (notes: string) => void;
}

const DetailsPanel: React.FC<DetailsPanelProps> = ({
    displayName,
    notes,
    niraBusId,
    existingScopeNames,
    onDisplayNameChange,
    onNotesChange
}) => {
    const { teamName } = useUserDataContext();
    const scopeNameResult = displayNameToScopeName(
        displayName,
        teamName,
        niraBusId,
        existingScopeNames
    );
    const [touched, setTouched] = useState(false);
    const showError = touched && !scopeNameResult.success;

    const onDisplayNameChanged = (value: string) => {
        setTouched(true);
        onDisplayNameChange(value);
    };

    return (
        <DialogBody className="DetailsPanel-body">
            <FormGroup
                label="Name"
                intent={showError ? "danger" : "none"}
                helperText={showError ? scopeNameResult.error : undefined}
            >
                <InputGroup
                    value={displayName}
                    onChange={(e) => onDisplayNameChanged(e.target.value)}
                    placeholder="My Custom Study"
                    intent={showError ? "danger" : "none"}
                />
            </FormGroup>
            <FormGroup label="Notes">
                <TextArea
                    value={notes}
                    onChange={(e) => onNotesChange(e.target.value)}
                    placeholder="Notes about this scope's assumptions..."
                    fill
                    rows={10}
                />
            </FormGroup>
        </DialogBody>
    );
};

export default DetailsPanel;
